import { Flex, TextV2 } from '@withjoy/joykit';
import React from 'react';
import { useStationeryTemplateProductPrices } from '../../hooks/useStationeryTemplateProductPrices';
import { StationeryTemplate } from '../../../../DesignsGallery.types';
import { CardTileDiscountedPriceLabel } from '../../../CardTileDiscountedPriceLabel';
import { useStationeryTemplateCategoryTranslations } from '@apps/card/hooks/useStationeryTemplateCategoryTranslations';

type ProductPricesProps = {
  template: Pick<StationeryTemplate, 'products' | 'category'>;
  explicitPaperDigitalCategory?: boolean;
};

export const ProductPrices = (props: ProductPricesProps) => {
  const { template, explicitPaperDigitalCategory = false } = props;
  const productPrices = useStationeryTemplateProductPrices(template);
  const getPaperCategoryName = useStationeryTemplateCategoryTranslations('stationeryTemplateCategoryToTile');
  const getDigitalCategoryName = useStationeryTemplateCategoryTranslations('stationeryTemplateCategoryToDigitalTile');

  return (
    <Flex flexDirection="column" gap="4px" justifyContent="center">
      {productPrices.map(product => {
        const isDiscountDifferent = product.preDiscountedPrice !== product.basePrice;
        const showDiscountedPrice = !!product.preDiscountedPrice && !!product.discount && isDiscountDifferent;

        const name = (() => {
          if (explicitPaperDigitalCategory) {
            if (product.name === 'Paper') return getPaperCategoryName(template.category);
            if (product.name === 'Digital') return getDigitalCategoryName(template.category);
          }

          return product.name;
        })();

        return (
          <div key={product.productId}>
            {showDiscountedPrice ? (
              <CardTileDiscountedPriceLabel
                showCode={false}
                prefixLabel={name}
                preDiscountPrice={product.preDiscountedPrice!}
                discountedPrice={product.basePrice}
                sale={product.discount!.fullPromoConfig}
              />
            ) : (
              <TextV2 typographyVariant="label2" margin="auto 0 auto 0">
                {name} {product.basePrice}
              </TextV2>
            )}
          </div>
        );
      })}
    </Flex>
  );
};
